import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/deals/[id]/messages/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = (id: number): string => `/deals/${id}/messages`;

const DealMessage: NextPage = () => (
  <>
    <NskHead title="施工会社とチャット" />
    <Component />
  </>
);

export default DealMessage;
